export default __webpack_public_path__ + "static/media/Revenue_Saas.f494dd44.xlsx";